import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../@types/validation-types'
import TextInput from '../../../../../common/inputs/textInput/TextInput'
import { cutToChosenDigitLength } from '../../../../../../services/conversion/conversionServices'
import Checkbox from '../../../../../common/inputs/checkbox/Checkbox'
import { getDefaultClasses } from '../../../../../../utils/style-utils'

export type ConstructionYearFieldProps = FieldProps<ConstructionScreenValidationResult>

const ConstructionYearField: React.FC<ConstructionYearFieldProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = getDefaultClasses('leftOnDesk'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='construction-year'
        propertyName='constructionYear'
        type='tel' // 'number' type does not trigger the onChange in safari - using 'tel' is the usual workaround!
        maxLength={4}
        label={<span>{t('wizard.screen.construction.constructionYear', 'Year')}</span>}
        placeholder={t('wizard.screen.construction.constructionYearPlaceholder', 'eg. 1998')}
        value={insertionData.constructionYear}
        errors={validationMessages!.constructionYear ?? []}
        doOnFieldChange={(field, value) =>
          onChange({ screen: screenName, property: field }, cutToChosenDigitLength(value as string, 4))
        }
        disabled={insertionData.unknownConstructionYear}
      />
      <div className='grid-item one-whole'>
        <Checkbox
          id='unknown-construction-year'
          onChange={(_name, checked) => onChange({ screen: screenName, property: 'unknownConstructionYear' }, checked)}
          name='unknownConstructionYear'
          checked={insertionData.unknownConstructionYear ?? false}
          label={<span>{t('wizard.screen.construction.unknownConstructionYear', 'unknown')}</span>}
        />
      </div>
    </div>
  )
}

export default ConstructionYearField
